import { lazy } from 'react';
import { route, routes } from "~/helpers/routeHelper";

const Dashboard = lazy(() => import("~/pages/Dashboard/index"));
const LeaderboardList = lazy(() => import("~/pages/Dashboard/Leaderboard"));
const UserList = lazy(() => import("~/pages/User/List"));
const UserView = lazy(() => import("~/pages/User/View"));
const UserNew = lazy(() => import("~/pages/User/New"));
const NotificationList = lazy(() => import("~/pages/Notification/List"));
const NotificationView = lazy(() => import("~/pages/Notification/View"));
const DealerGroupList = lazy(() => import("~/pages/DealerGroup/List"));
const DealerGroupView = lazy(() => import("~/pages/DealerGroup/View"));
const DealerGroupNew = lazy(() => import("~/pages/DealerGroup/New"));
const DealerGroupNewManager = lazy(() => import("~/pages/DealerGroup/New/Manager"));
const DealerRegionView = lazy(() => import("~/pages/DealerRegion/View"));
const DealerRegionNew = lazy(() => import("~/pages/DealerRegion/New"));
const DealerRegionNewManager = lazy(() => import("~/pages/DealerRegion/New/Manager"));
const DealerStoreList = lazy(() => import("~/pages/DealerStore/List"));
const DealerStoreView = lazy(() => import("~/pages/DealerStore/View"));
const DealerStoreViewActivity = lazy(() => import("~/pages/DealerStore/View/Activity"));
const DealerStoreNew = lazy(() => import("~/pages/DealerStore/New/index"));
const DealerStoreNewUser = lazy(() => import("~/pages/DealerStore/New/User"));
const OrderList = lazy(() => import("~/pages/Order/List"));
const OrderViewIndex = lazy(() => import("~/pages/Order/View"));
const OrderViewVid = lazy(() => import("~/pages/Order/View/Vid"));
const OrderViewESign = lazy(() => import("~/pages/Order/View/ESign"));
const OrderViewInkSign = lazy(() => import("~/pages/Order/View/InkSign"));
const OrderViewFinance = lazy(() => import("~/pages/Order/View/Finance"));
const OrderViewSupporting = lazy(() => import("~/pages/Order/View/Supporting"));
const OrderViewActivity = lazy(() => import("~/pages/Order/View/Activity"));
const OrderViewMessages = lazy(() => import("~/pages/Order/View/Messages"));
const OrderViewScheduler = lazy(() => import("~/pages/Order/View/Scheduler"));
const OrderViewNotary = lazy(() => import("~/pages/Order/View/Notary"));
const OrderViewNotaryInformation = lazy(() => import("~/pages/Order/View/NotaryInformationStatus"));
const OrderViewNotaryManualSearch = lazy(() => import("~/pages/Order/View/NotaryManualSearch"));
const OrderViewNotaryClosestList = lazy(() => import("~/pages/Order/View/NotaryClosestList"));
const OrderViewBiddingLogs = lazy(() => import("~/pages/Order/View/BiddingLogs"));
const OrderViewAccountingEdit = lazy(() => import("~/pages/Order/Partial/Form/Edit/Accounting/AccountingEdit"));
const Seal = lazy(() => import("~/pages/Order/View/Seal"));
const PaymentPlanList = lazy(() => import("~/pages/PaymentPlan/List"));
const PaymentPlanView = lazy(() => import("~/pages/PaymentPlan/View"));
const PaymentPlanNew = lazy(() => import("~/pages/PaymentPlan/New"));
const DealerStoreSignerNew = lazy(() => import("~/pages/DealerStoreSigner/New"));
const DealerStoreSignerView = lazy(() => import("~/pages/DealerStoreSigner/View"));
const MessageList = lazy(() => import("~/pages/Message/List"));
const SupportCaseList = lazy(() => import("~/pages/SupportCase/List"));
const SupportCaseView = lazy(() => import("~/pages/SupportCase/View"));
const NotaryList = lazy(() => import("~/pages/Notary/List"));
const NotaryView = lazy(() => import("~/pages/Notary/View"));
const NotaryActivityLogs = lazy(() => import("~/pages/Notary/ActivityLogs"));
const NotaryActivityLogView = lazy(() => import("~/pages/Notary/ActivityLogView"));
const AdditionalFeeList = lazy(() => import("~/pages/AdditionalFee/List"));
const AdditionalFeeView = lazy(() => import("~/pages/AdditionalFee/View"));
const AddOnList = lazy(() => import("~/pages/AddOn/List"));
const AddOnView = lazy(() => import("~/pages/AddOn/View"));
const SchedulerPerformanceReport = lazy(() => import("~/pages/PerformanceReport/Scheduler"));
const Quickbooks = lazy(() => import("~/pages/Quickbooks/View/Quickbooks"));
const ChatTemplate = lazy(() => import("~/pages/ChatTemplates"));
const PaymentsList = lazy(() => import("~/pages/Payments/List"));
const PaymentView = lazy(() => import("~/pages/Payments/View"));
const DealersAccountingList = lazy(() => import("~/pages/Accounting/Dealer/List"));
const NotariesAccountingList = lazy(() => import("~/pages/Accounting/Notary/List"));
const SubscriptionStatementsList = lazy(() => import("~/pages/Statement/Subscription/List"));
const SubscriptionStatementsView = lazy(() => import("~/pages/Statement/Subscription/View"));
const BiddingsList = lazy(() => import('~/pages/Bidding/List'));
const GroupUsageReport = lazy(() => import("~/pages/GroupUsageReport/GroupUsage"));
const CronJobList = lazy(() => import("~/pages/CronJob/List"));
const CronJobView = lazy(() => import("~/pages/CronJob/View"));
const ErrorCodesList = lazy(() => import("~/pages/Dev/ListErrCodes"));
const SysProcessList = lazy(() => import("~/pages/Dev/ListProcesses"));
const SysProcessView = lazy(() => import("~/pages/Dev/ViewProcess"));
const PendingReviewOrderList = lazy(() => import("~/pages/PendingReview/List"));
const RemoteOrderList = lazy(() => import("~/pages/Order/Remote/List"));
const InStoreOrderList = lazy(() => import("~/pages/Order/InStore/List"));
const OrderPreviewList = lazy(() => import("~/pages/Order/Preview/List"));
const DealerSalesReport = lazy(() => import("~/pages/DealerSalesReport/DealerSales"));
const NewDealersReport = lazy(() => import("~/pages/NewDealersReport/NewDealers"));
const HelpList = lazy(() => import("~/pages/Help/List"));
const OrderViewChannel = lazy(() => import("~/pages/Order/View/Channel"));
const InsuranceVerificationIndex = lazy(() => import("~/pages/Order/Partial/InsuranceVerification"));
const RouteOne = lazy(() => import("~/pages/MarketingPages/RouteOne"));
const RouteOneLogsList = lazy(() => import("~/pages/Dev/ListRouteOneLogs"));
const RouteOneLogView = lazy(() => import("~/pages/Dev/Partial/View/RouteOneLogInfo"));
const GenerateLabelIndex = lazy(() => import("~/pages/Order/Partial/GenerateLabel"));
const SubscriptionCancellationRequestsView = lazy(() => import("~/pages/CancellationRequests/List"));
const Fedex = lazy(() => import("~/pages/MarketingPages/Fedex"));
const Vehicles = lazy(() => import("~/pages/Vehicles/List"));
const InsuranceVerification = lazy(() => import("~/pages/MarketingPages/InsuranceVerification"));
const GeneratedLabelsList = lazy(() => import("~/pages/Dev/ListGeneratedLabels"));
const XrmLogsList = lazy(() => import("~/pages/Dev/ListXrmLogs"));
const AuthLogsList = lazy(() => import("~/pages/Dev/ListAuthLogs"));
const CoupaLogsList = lazy(() => import("~/pages/Dev/ListCoupaLogs"));
const CoupaLogView = lazy(() => import("~/pages/Dev/Partial/View/CoupaLogInfo"));
const QbLogsList = lazy(() => import("~/pages/Dev/ListQbLogs"));
const QbLogView = lazy(() => import("~/pages/Dev/Partial/View/QbLogInfo"));
const CommercialOrders = lazy(() => import("~/pages/MarketingPages/CommercialOrders"));
const SchedulerPullingList = lazy(() => import("~/pages/SchedulerPulling/List"));

const publicRoutes = [

];

const protectedRoutes = [
  { path: route(routes.list_users), component: UserList },
  { path: route(routes.view_user), component: UserView },
  { path: route(routes.new_user), component: UserNew },

  { path: route(routes.list_dealer_groups), component: DealerGroupList },
  { path: route(routes.view_dealer_group), component: DealerGroupView },
  { path: route(routes.new_dealer_group), component: DealerGroupNew },
  { path: route(routes.new_dealer_group_region), component: DealerRegionNew },
  { path: route(routes.new_dealer_group_manager), component: DealerGroupNewManager },

  { path: route(routes.view_dealer_region), component: DealerRegionView },
  { path: route(routes.new_dealer_region_manager), component: DealerRegionNewManager },

  { path: route(routes.list_dealer_stores), component: DealerStoreList },
  { path: route(routes.view_dealer_store), component: DealerStoreView },
  { path: route(routes.view_dealer_store_activity), component: DealerStoreViewActivity },
  { path: route(routes.new_dealer_store), component: DealerStoreNew },
  { path: route(routes.new_dealer_store_user), component: DealerStoreNewUser },
  { path: route(routes.new_dealer_store_signer), component: DealerStoreSignerNew },

  { path: route(routes.view_dealer_store_signer), component: DealerStoreSignerView },

  { path: route(routes.list_notaries), component: NotaryList },

  { path: route(routes.list_notifications), component: NotificationList },
  { path: route(routes.view_notification), component: NotificationView },

  { path: route(routes.list_orders), component: OrderList },
  { path: route(routes.list_orders_remote), component: RemoteOrderList },
  { path: route(routes.list_orders_in_store), component: InStoreOrderList },
  { path: route(routes.list_orders_preview), component: OrderPreviewList },
  { path: route(routes.view_order), component: OrderViewIndex },
  { path: route(routes.view_order_vid), component: OrderViewVid },
  { path: route(routes.view_order_e_sign), component: OrderViewESign },
  { path: route(routes.view_order_ink_sign), component: OrderViewInkSign },
  { path: route(routes.view_order_finance), component: OrderViewFinance },
  { path: route(routes.view_order_supporting), component: OrderViewSupporting },
  { path: route(routes.view_order_activity), component: OrderViewActivity },
  { path: route(routes.view_order_messages), component: OrderViewMessages },
  { path: route(routes.view_order_channel), component: OrderViewChannel },
  { path: route(routes.view_order_scheduler), component: OrderViewScheduler },
  { path: route(routes.view_order_notary), component: OrderViewNotary },
  { path: route(routes.view_order_notary_manual_search), component: OrderViewNotaryManualSearch },
  { path: route(routes.view_order_notary_closest_list), component: OrderViewNotaryClosestList },
  { path: route(routes.view_order_notary_information), component: OrderViewNotaryInformation },
  { path: route(routes.view_order_bidding_logs), component: OrderViewBiddingLogs },
  { path: route(routes.list_pending_review_orders), component: PendingReviewOrderList },
  { path: route(routes.view_order_generate_label), component: GenerateLabelIndex },
  { path: route(routes.view_order_insurance), component: InsuranceVerificationIndex },

  { path: route(routes.view_quickbooks), component: Quickbooks },

  { path: route(routes.view_subscription_cancellation_requests), component: SubscriptionCancellationRequestsView },

  { path: route(routes.view_accounting_edit), component: OrderViewAccountingEdit },

  { path: route(routes.view_seal), component: Seal },

  { path: route(routes.view_notary), component: NotaryView },
  { path: route(routes.list_notary_activity_logs), component: NotaryActivityLogs },
  { path: route(routes.view_notary_activity_log), component: NotaryActivityLogView },

  { path: route(routes.view_scheduler_performance_report), component: SchedulerPerformanceReport },
  { path: route(routes.view_group_usage_report), component: GroupUsageReport },
  { path: route(routes.view_dealer_sales_report), component: DealerSalesReport },
  { path: route(routes.view_new_dealers_report), component: NewDealersReport },

  { path: route(routes.list_payment_plans), component: PaymentPlanList },
  { path: route(routes.view_payment_plan), component: PaymentPlanView },
  { path: route(routes.new_payment_plan), component: PaymentPlanNew },

  { path: route(routes.list_messages), component: MessageList },

  { path: route(routes.list_leaderboard), component: LeaderboardList },

  { path: route(routes.list_support_cases), component: SupportCaseList },
  { path: route(routes.view_support_case), component: SupportCaseView },

  { path: route(routes.home), component: Dashboard },

  { path: route(routes.list_additional_fees), component: AdditionalFeeList },
  { path: route(routes.view_additional_fee), component: AdditionalFeeView },

  { path: route(routes.list_addons), component: AddOnList },
  { path: route(routes.view_addon), component: AddOnView },

  { path: route(routes.list_payments), component: PaymentsList },
  { path: route(routes.view_payment), component: PaymentView },

  { path: route(routes.list_subscription_statements), component: SubscriptionStatementsList },
  { path: route(routes.view_subscription_statement), component: SubscriptionStatementsView },

  { path: route(routes.list_dealer_accounting), component: DealersAccountingList },

  { path: route(routes.list_notary_accounting), component: NotariesAccountingList },

  { path: route(routes.view_biddings), component: BiddingsList },

  { path: route(routes.list_cron_jobs), component: CronJobList },
  { path: route(routes.view_cron_job), component: CronJobView },
  { path: route(routes.list_error_codes), component: ErrorCodesList },
  { path: route(routes.list_sys_processes), component: SysProcessList },
  { path: route(routes.view_sys_process), component: SysProcessView },
  { path: route(routes.list_route_one_logs), component: RouteOneLogsList },
  { path: route(routes.view_route_one_log), component: RouteOneLogView },
  { path: route(routes.list_generated_labels), component: GeneratedLabelsList },

  { path: route(routes.list_help), component: HelpList },

  { path: route(routes.route_one), component: RouteOne },

  { path: route(routes.view_fedex), component: Fedex },

  { path: route(routes.view_vehicles), component: Vehicles },

  { path: route(routes.view_insurance_verification), component: InsuranceVerification },

  { path: route(routes.view_commercial_orders), component: CommercialOrders },

  { path: route(routes.list_chat_templates), component: ChatTemplate },

  { path: route(routes.list_xrm_logs), component: XrmLogsList },

  { path: route(routes.list_auth_logs), component: AuthLogsList },

  { path: route(routes.list_coupa_logs), component: CoupaLogsList },
  { path: route(routes.view_coupa_log), component: CoupaLogView },

  { path: route(routes.list_qb_logs), component: QbLogsList },
  { path: route(routes.view_qb_log), component: QbLogView },

  { path: route(routes.list_scheduler_pulling), component: SchedulerPullingList },

];

export { publicRoutes, protectedRoutes }
